import i18next from 'i18next';

export const CENTRAL_KITCHEN_PRODUCT_DETAILS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.PRODUCTS.CREATION_INFO'),
  path: '/admin/kitchen-products/products/:id/details',
  getLink: ({ product: { id } }) => `/admin/kitchen-products/products/${id}/details`,
};

export const CENTRAL_KITCHEN_PRODUCT_B2B_CATALOGS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_TAB'),
  path: '/admin/kitchen-products/products/:id/b2b-catalogs',
  getLink: ({ product: { id } }) => `/admin/kitchen-products/products/${id}/b2b-catalogs`,
};

export const CENTRAL_KITCHEN_PRODUCT_SUPPLIER_PRODUCTS = {
  isFullScreen: true,
  shouldReplacePath: true,
  getText: () => i18next.t('ADMIN.CENTRAL_PRODUCTS.LINKED_SUPPLIER_PRODUCTS_TAB'),
  path: '/admin/kitchen-products/products/:id/supplier-products',
  getLink: ({ product: { id } }) => `/admin/kitchen-products/products/${id}/supplier-products`,
};

export const CENTRAL_KITCHEN_PRODUCT_CREATION = {
  isFullScreen: true,
  isVisible: () => false,
  path: '/admin/kitchen-products/products/create',
};
